import * as React from "react";
import { Stack, useFocusEffect } from "expo-router";

import { ModalHeaderTitle } from "~/components/HeaderElements";
import SaveFormAddURL from "~/components/SaveForm/SaveForm.addLink";
import { useSaveFormContext } from "~/components/SaveForm/shared";

export default function LinkIndexPage() {
  const { setValue, getValues } = useSaveFormContext();

  const saveType = getValues("type");

  useFocusEffect(() => {
    switch (saveType) {
      case "URL": {
        setValue("step", "addUrl");
        break;
      }
      case "MEDIA": {
        setValue("step", "showAsset");
        break;
      }
    }
  });

  return (
    <>
      <Stack.Screen
        options={{
          headerTitle() {
            if (saveType === "URL") {
              return <ModalHeaderTitle>Add link</ModalHeaderTitle>;
            }
            if (saveType === "MEDIA") {
              return <ModalHeaderTitle>Add media</ModalHeaderTitle>;
            }
            return <ModalHeaderTitle>-</ModalHeaderTitle>;
          },
        }}
      />

      <SaveFormAddURL />
    </>
  );
}
